export default __webpack_public_path__ + "static/media/epilogDiscovery.18737ea3.png";